export default "__VITE_ASSET__BnZz6K9v__"